import script from "./AnnoucementBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnoucementBar.vue?vue&type=script&setup=true&lang=js"

import "./AnnoucementBar.vue?vue&type=style&index=0&id=41a7a140&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a7a140"]])

export default __exports__